import type { RootState } from "..";
import type { Trace } from "./types";

/**
 * Traces recorded within a half-open time window `(fromPerf, toPerf]` (perf-clock milliseconds).
 *
 * Used to attribute the causing events to a render pass: a pass starting at `T`, preceded by a pass
 * starting at `T_prev`, was caused by the traces with `perfTime ∈ (T_prev, T]`.  For the first pass,
 * pass `-Infinity` as `fromPerf`.
 */
export function tracesInWindow(traces: Trace[], fromPerf: number, toPerf: number): Trace[] {
    return traces.filter(t => t.perfTime > fromPerf && t.perfTime <= toPerf);
}

export const selectTraces = (state: RootState): Trace[] => state.tracing.traces;
export const selectTracingEnabled = (state: RootState): boolean => state.tracing.enabled;
